import React, { useState } from 'react';
import { Box, Typography, Button, useTheme, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { useNavigate } from 'react-router-dom';
import CreateContractDialog from '../dialogs/CreateContractDialog';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../components/CustomButton';
import TutorialPinpoint from '../../../components/TutorialPinpoint';
import { isMobile } from '../../../utils/utils';

const DashboardHeader = ({ title, onVideoClick }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleOpenDialog = () => {
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const handleContractCreated = (contractId) => {
        // Navigate to the contract will be handled within the dialog
        // This callback can be used for additional actions if needed
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: { xs: 'space-between', sm: 'space-between' },
                    alignItems: 'center',
                    py: 2.2,
                    pb: 3,
                    gap: { xs: 1, sm: 0 }
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: { xs: 1, sm: 2 },
                    flex: { xs: 1, sm: 'none' }
                }}>
                    <Typography
                        variant="h5"
                        component="h1"
                        sx={{
                            fontWeight: 700,
                            color: theme.palette.text.primary,
                            fontSize: { xs: '1.1rem', sm: '1.25rem' },
                            fontFamily: theme.typography.h1?.fontFamily
                            // letterSpacing: '-0.5px'
                        }}
                    >
                        {title}
                    </Typography>
                    {onVideoClick && (
                        <TutorialPinpoint storageKey="tutorial_pinpoint_clm">
                            <IconButton
                                onClick={onVideoClick}
                                size="small"
                                sx={{
                                    bgcolor: 'primary.main',
                                    color: theme.palette.mode === 'dark' ? '#000' : '#fff',
                                    '&:hover': {
                                        bgcolor: 'primary.dark',
                                    },
                                    flexShrink: 0
                                }}
                                title={t('tutorial_video')}
                            >
                                <PlayCircleIcon fontSize="small" />
                            </IconButton>
                        </TutorialPinpoint>
                    )}
                </Box>

                <CustomButton
                    data-tour="contract-create-btn"
                    text={isMobile() ? 'Créer' : t('new_contract')}
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenDialog}
                    sx={{
                        borderRadius: 2,
                        px: { xs: 2, sm: 3 },
                        py: 1,
                        fontWeight: 600,
                        boxShadow: theme.palette.mode === 'dark' ? '0 1px 2px rgba(0, 0, 0, 0.2)' : '0 1px 2px rgba(0, 0, 0, 0.05)',
                        flexShrink: 0,
                        '& .MuiButton-label': {
                            display: { xs: 'none', sm: 'flex' }
                        }
                    }}
                />
            </Box>

            {/* Contract Creation Dialog */}
            <CreateContractDialog
                open={isDialogOpen}
                onClose={handleCloseDialog}
                onSuccess={handleContractCreated}
            />
        </>
    );
};

export default DashboardHeader;